module.exports = __webpack_public_path__ + "static/media/logo.033592f3.svg";